export default __webpack_public_path__ + "static/media/select-one.51c55051.svg";